import logisticsApi from "services/logisticsApi";
import {
  CoverageAreaProps,
  CoverageAreasListResponse,
  CoverageAreaSummaryDto,
} from "store/modules/Logistics/types.store";
import {
  mapCoverageAreaDetail,
  normalizeCoverageAreaType,
} from "./mapCoverageAreaDetail";

export function mapCoverageAreaSummary(
  summary: CoverageAreaSummaryDto,
): CoverageAreaProps {
  return {
    id: summary.id,
    name: summary.name,
    type: normalizeCoverageAreaType(summary.type),
    dealer: summary.dealer,
    enabled: summary.dealer?.enabled ?? true,
    map: { link: "", geoJson: {} },
    openingHours: [],
    holidayOpeningHours: [],
    hasDriver: false,
    storeUri: "",
    holidays: [],
    drivers: [],
  };
}

export async function getDealerCoverageAreaDetail(
  dealerId: string,
  coverageAreaId: string,
): Promise<CoverageAreaProps> {
  const { data } = await logisticsApi.get(
    `/v1/dealers/${dealerId}/coverage-areas/${coverageAreaId}`,
  );

  return mapCoverageAreaDetail(data, dealerId);
}

export async function getDealerCoverageAreas(
  dealerId: string,
): Promise<CoverageAreaProps[]> {
  const { data } = await logisticsApi.get<CoverageAreasListResponse>(
    `/v1/dealers/${dealerId}/coverage-areas`,
  );

  return data.data.map(mapCoverageAreaSummary);
}
